import React from 'react'
import {useSelector} from 'react-redux'
import {getUserCountryCode} from 'modules/meta/selectors'
import {getShowTotalPrices} from 'modules/sapiSearch/selectors'
import {imageProvider} from 'utils/imageProvider'

import {getTaxDisplayLogic} from '@daedalus/core/src/localization/business/countries'
import {HotelInfoCard} from '@daedalus/shared/src/booking/HotelInfoCard'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types/types'

export const HotelCardInfoContainer = ({hotel}: {hotel: ContentHotel}) => {
  const userCountry = useSelector(getUserCountryCode)
  const showTotalPrices = useSelector(getShowTotalPrices) //check if its the right place

  const taxDisplayLogic = getTaxDisplayLogic(userCountry)
  if (!hotel) return null

  const {includeLocalTaxes, includeTaxes} = taxDisplayLogic

  const {
    imageURIs,
    starRating,
    hotelName,
    placeDisplayName,
    guestRating,
    reviewCount,
    objectID: hotelId
  } = hotel || {}

  return (
    <HotelInfoCard
      showTotalPrices={showTotalPrices}
      imageProvider={imageProvider}
      hotelImageUrl={imageURIs?.[0]}
      starRating={starRating}
      hotelName={hotelName}
      place={placeDisplayName}
      hotelId={hotelId}
      reviewRaiting={guestRating.overall}
      totalRatingCount={reviewCount}
      includeTaxes={includeLocalTaxes || includeTaxes}
    />
  )
}
